module.exports = __webpack_public_path__ + "officialStatic/img/product-xyaqxt.ec1607f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-xyaqxt.png
// module id = +35Y
// module chunks = 0